var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isLoaded)?_c('AppLoadingScreen'):_vm._e(),_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],staticClass:"appFrame",attrs:{"allow":"clipboard-write","src":_vm.fullUrl},on:{"load":function($event){_vm.isLoaded = true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }